import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_orders } from "../../store/reducers/orderReducer";
import { formatCurrency } from "../../utils/currencyUtils";
import { useCurrency } from "../../hooks/useCurrency";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
const Orders = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { myOrders } = useSelector((state) => state.order);
  const { currencyCode, exchangeLoaded } = useCurrency();
  const [state, setState] = useState("all");

  useEffect(() => {
    dispatch(get_orders({ status: state, customerId: userInfo.id }));
  }, [state]);

  const redirect = (ord) => {
    let items = 0;
    for (let i = 0; i < ord.products.length; i++) {
      items = ord.products[i].quantity + items;
    }
    navigate("/payment", {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
        name: ord.shippingInfo.name
      },
    });
  };

  return (
    <div className="bg-white border border-gray-100 shadow-sm p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-gray-900">My Orders</h2>
        <Select value={state} onValueChange={(value) => setState(value)}>
          <SelectTrigger className="w-max text-gray-700 font-semibold px-5 h-[40px] ">
            <SelectValue placeholder="--order status--" />
          </SelectTrigger>
          <SelectContent className="nex_drop">
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="placed">Placed</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="cancelled">Cancelled</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="pt-4">
        <div className="relative overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-700">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Order Id
                </th>
                <th scope="col" className="px-6 py-3">
                  Price
                </th>
                <th scope="col" className="px-6 py-3">
                  Payment status
                </th>
                {/* <th scope="col" className="px-6 py-3">
                  Order status
                </th> */}
                <th scope="col" className="px-6 py-3">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {myOrders.map((o, i) => (
                <tr key={i} className="bg-white border-b border-gray-100 text-gray-700">
                  <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {o._id}
                  </td>
                  <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {formatCurrency(o.price, currencyCode, exchangeLoaded)}
                  </td>
                  <td className="px-6 py-4 font-medium whitespace-nowrap">
                    {o.payment_status}
                  </td>
                  <td className="px-6 py-4 flex gap-2">
                    <Link to={`/dashboard/order/details/${o._id}`}>
                      <span className="bg-gray-100 text-gray-700 hover:bg-gray-200 text-xs whitespace-nowrap font-medium px-4 py-1 rounded transition-colors">
                        view
                      </span>
                    </Link>
                    {o.payment_status !== "paid" && (
                      <span
                        onClick={() => redirect(o)}
                        className="whitespace-nowrap cursor-pointer bg-indigo-600 text-white hover:bg-indigo-700 text-xs font-medium px-4 py-1 rounded transition-colors"
                      >
                        Pay Now
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Orders;
